import { AppState } from '@chegg-wt/core/state'
import {
  createCitationEncodedQuerySelector,
  createCitationSourceTypeSelector,
} from '@chegg-wt/core/state/createCitation/selectors'
import {
  currentProjectIdSelector,
  currentStyleSelector,
} from '@chegg-wt/core/state/currentProject/selectors'
import { isProSelector, isUserEduSelector } from '@chegg-wt/core/state/user/selectors'
import { activeCitationIdSelector } from '@chegg-wt/core/state/citation/selectors'
import { createSelector } from 'reselect'
import { AppRouteParams } from '@chegg-wt/core/types/core'

export const adzoneSelector = (state: AppState) => state.app.adzone

export const adLayoutSelector = (state: AppState) => state.app.adLayoutName

export const sbmLoadedSelector = (state: AppState) => state.app.sbmLoaded

export const currentRouteSelector = (state: AppState) => state.app.currentRoute

export const enableFoldersSelector = (state: AppState) => state.app.enableFolders

export const initializedSelector = (state: AppState) => state.app.initialized

export const updateMessagingFlagSelector = (state: AppState) =>
  state.app.updateMessagingFlag

export const adzoneSBMSelector = createSelector(
  [adzoneSelector, isProSelector, isUserEduSelector],
  (adzone, isPro, userEdu) => {
    if (isPro) return 'pro'
    if (userEdu) return 'edu'
    if (adzone) return adzone
    return 'homepage'
  }
)

export const routeParamsSelector = createSelector(
  [
    currentStyleSelector,
    createCitationSourceTypeSelector,
    currentProjectIdSelector,
    createCitationEncodedQuerySelector,
    activeCitationIdSelector,
  ],
  (style, sourceType, projectId, query, citationId): AppRouteParams => ({
    style,
    sourceType,
    projectId,
    query,
    citationId,
  })
)

export const isDashboardPage = () => {
  return /\/dashboard/g.test(document.location.href)
}
